"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var CodeType_1 = require("../model/CodeType"),
    ClientConfig_1 = require("./ClientConfig"),
    DeviceSupport_1 = require("./DeviceSupport"),
    GapBridgingConfig_1 = require("./GapBridgingConfig"),
    OfflineConfig_1 = require("./OfflineConfig"),
    InitialisationResponse = function InitialisationResponse(e) {
  this.codeSetTypes = [], this.sessionToken = "";
  var i = e.codeSetTypes,
      n = e.ppi,
      o = e.devicePixelRatio;
  this.gapBridgingConfig = new GapBridgingConfig_1.GapBridgingConfig(e.gapBridgingConfig);

  for (var t = 0, s = i; t < s.length; t++) {
    var p = s[t];
    this.codeSetTypes.push(CodeType_1.CodeType[p]);
  }

  this.ppi = n, this.devicePixelRatio = o, e.clientConfig && (this.clientConfig = new ClientConfig_1.ClientConfig(e.clientConfig)), e.deviceSupport && (this.deviceSupport = new DeviceSupport_1.DeviceSupport(e.deviceSupport)), e.sessionToken && (this.sessionToken = e.sessionToken), e.offlineConfig && (this.offlineConfig = new OfflineConfig_1.OfflineConfig(e.offlineConfig)), e.expectedTouchRadius && (this.expectedTouchRadius = e.expectedTouchRadius);
};

exports.InitialisationResponse = InitialisationResponse;